import axios from "utils/axios";
import { getOrigin } from "utils/method";

const URL = "/xt-app/";

//滑块验证码初始化接口
export function post_captchaApply(config) {
  return axios.post(
    URL + `public/captcha/apply?ts=${Date.now()}`,
    null,
    config
  );
}

//滑块验证码分析接口
export function post_captchaValidate(config) {
  return axios.post(URL + `public/captcha/validate`, null, config);
}

//滑块验证码初始化接口v2
export function post_captchaApplyV2(config) {
  return axios.post(
    URL + `public/captcha/v2/apply?ts=${Date.now()}`,
    null,
    config
  );
}

//滑块验证码分析接口
export function post_captchaValidateV2(config) {
  return axios.post(URL + `public/captcha/v2/validate`, null, config);
}